import "./Faq.scss";

import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { FaChevronDown } from "react-icons/fa";

import GridBackground from "../../../components/GridBackground/GridBackground";
import Section from "../../../components/Section/Section";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";

const Faq = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const items = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <Section id="faq" className="faq">
      <GridBackground />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <SectionHeader
        tag={t("faq.tag")}
        title={t("faq.title")}
        subtitle={t("faq.subtitle")}
      />
      <div className="faqList">
        {items.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              className={`faqItem fi ${isOpen ? "open" : ""}`}
            >
              <button
                className="faqQuestion"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
              >
                <span>{item.q}</span>
                <FaChevronDown
                  className={`faqIcon ${isOpen ? "open" : ""}`}
                  aria-hidden="true"
                />
              </button>
              <div className="faqAnswer">
                <p>{item.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default Faq;
